import { formatInTimeZone } from "date-fns-tz";

export default function formatDate(now = new Date(), timeZone = "Europe/Stockholm", formatting = "yyyy-MM-dd") {
	return formatInTimeZone(now, timeZone, formatting);
}
